import React from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'
import noimage from "../images/notfound.png"
import styles from '../styles/error.module.css'

function Error() {
  const navigate = useNavigate()
  return (
    <div className={styles.error}>
      <Navbar />
      <div className={styles.e}>
        <img src={noimage} className={styles.error_img} alt="Page not found" />
        <h2 className={styles.errorTitle}>Oops! Page Not Found</h2>
        <p className={styles.errorMessage}>The page you are looking for might have been removed or is temporarily unavailable.</p>
        <button className={styles.gobacktohome} onClick={() => { navigate("/") }}>
          Go Home
        </button>
      </div>
    </div>
  )
}

export default Error